module.exports = __webpack_public_path__ + "img/db.a1495e4e.svg";